import { Observable } from './observable.js';

export interface ObservableEventListenerOptions {
    capture?: boolean;
    passive?: boolean;
};

/**
 * This is a temporary helper function to create an Observable from an EventTarget as an alternative to a global polyfill.
 *
 * When the draft proposal for EventTargetObservable is implemented, this function can be removed.
 * This will be available as target.when('event') in the future.
 *
 * @param target the EventTarget to listen for events on
 * @param type a string representing the event type to listen for on the given target
 * @returns an Observable that emits events of the given type
 */
// overloads for typing
export function when<T extends keyof HTMLElementEventMap>(target: HTMLElement, event: T, options?: ObservableEventListenerOptions): Observable<HTMLElementEventMap[T]>;
export function when<T extends keyof WindowEventMap>(target: Window, event: T, options?: ObservableEventListenerOptions): Observable<WindowEventMap[T]>;
export function when<T extends keyof DocumentEventMap>(target: Document, event: T, options?: ObservableEventListenerOptions): Observable<DocumentEventMap[T]>;
// the actual implementation
export function when(target: EventTarget, type: string, options?: ObservableEventListenerOptions): Observable<Event> {
    return new Observable<Event>(subscriber => {
        target.addEventListener(type, event => subscriber.next(event), { ...options, signal: subscriber.signal });
    });
}
